/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, FormControl, InputLabel, Checkbox, FormHelperText } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, Box, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes, { func } from 'prop-types'
import { useTheme, alpha } from '@material-ui/core/styles';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import SearchNotFound from '../../../SearchNotFound';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Chip from '@material-ui/core/Chip';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import Paper from '@mui/material/Paper';
import { AlertDialog } from './../../Common/AlertDialog';


var screenCode = "STOCKMANAGEMENT"

function getUomLabel(measuringUnit) {
    const normalized = Number(measuringUnit);
    if (normalized === 1) return 'Unit';
    if (normalized === 2) return 'Kg';
    if (normalized === 3) return 'g';
    return '';
}

function getAvailableStock(row) {
    if (!row) return 0;
    const direct = row.availableQuantity;
    if (direct !== undefined && direct !== null && direct !== '') {
        const num = Number(direct);
        return Number.isFinite(num) ? num : 0;
    }
    return 0;
}

function getStockIndicatorVariant(stockInKg) {
    const value = Number(stockInKg);
    if (!Number.isFinite(value)) return 'error';
    if (value <= 100) return 'error';
    if (value <= 150) return 'warning';
    return 'success';
}

function getStockIndicatorTitle(stockInKg) {
    const value = Number(stockInKg);
    if (!Number.isFinite(value)) return 'Stock level unknown';
    if (value <= 100) return 'Low stock (<= 100 KG)';
    if (value <= 150) return 'Medium stock (101–150 KG)';
    return 'High stock (> 150 KG)';
}

function getStockPillStyles(theme, indicatorVariant) {
    const paletteKey = indicatorVariant === 'error' ? 'error' : indicatorVariant === 'warning' ? 'warning' : 'success';
    const main = theme?.palette?.[paletteKey]?.main;
    const bg = main ? alpha(main, 0.25) : undefined;
    const border = main ? alpha(main, 0.35) : undefined;
    const color = theme?.palette?.text?.primary;
    return { bg, border, color };
}

function StockRow({ row, theme, pillClassName }) {
    const uom = getUomLabel(row.measuringUnit);
    const availableStock = getAvailableStock(row);
    const stockInKg = row.measuringUnit == 3 ? availableStock / 1000 : availableStock;
    const indicatorVariant = getStockIndicatorVariant(stockInKg);
    const indicatorTitle = getStockIndicatorTitle(stockInKg);
    const pill = getStockPillStyles(theme, indicatorVariant);

    return (
        <TableRow>
            <TableCell>{row.productCategoryName}</TableCell>
            <TableCell>{row.productCode || row.skuCode || ''}</TableCell>
            <TableCell>{row.productName}</TableCell>
            <TableCell>{uom}</TableCell>
            <TableCell align="right">
                <Box
                    component="span"
                    title={indicatorTitle}
                    className={pillClassName}
                    style={{
                        display: 'inline-block',
                        padding: '6px 14px',
                        borderRadius: 999,
                        minWidth: 90,
                        textAlign: 'center',
                        backgroundColor: pill.bg,
                        borderColor: pill.border,
                        color: pill.color,
                        fontWeight: 600
                    }}
                >
                    <Box component="span" style={{ position: 'relative', zIndex: 1 }}>
                        {Number(availableStock).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Box>
                </Box>
            </TableCell>
        </TableRow>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    },
    stockPill: {
        position: 'relative',
        overflow: 'hidden',
        borderWidth: 1,
        borderStyle: 'solid',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        boxShadow: theme.shadows[1],
        '&:before': {
            content: '""',
            position: 'absolute',
            top: -24,
            left: -40,
            width: '60%',
            height: '160%',
            background: `linear-gradient(120deg, ${alpha(theme.palette.common.white, 0.65)}, ${alpha(theme.palette.common.white, 0)})`,
            transform: 'rotate(20deg)',
            pointerEvents: 'none'
        },
        '&:after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `radial-gradient(circle at 30% 20%, ${alpha(theme.palette.common.white, 0.35)}, ${alpha(theme.palette.common.white, 0)} 60%)`,
            pointerEvents: 'none'
        }
    }
}));

export default function StockManagement(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const theme = useTheme();

    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('productForecastdate');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcategory, setProductcategory] = useState([]);
    const [stockBalanceDetails, setStockBalanceDetails] = useState([]);
    const [formData, setFormData] = useState({
        groupID: 0,
        factoryID: 0,
        productCategoryID: 0,
        productID: 0,
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isFreezeEnabled: false
    });
    const [freezeStatus, setFreezeStatus] = useState({ isFrozen: false });
    const [EnableFreezeConfirm, setEnableFreezeConfirm] = useState(false);
    const [EnableUnfreezeConfirm, setEnableUnfreezeConfirm] = useState(false);

    const validationSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        factoryID: Yup.number().min(1, 'Please Select Factory').required('Factory Required'),
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        factoryID: '',
        productCategoryID: '',
        productID: '',
    });

    async function createFile() {
        const content = (stockBalanceDetails || []).map((row) => ({
            'Product Category': row.productCategoryName || '',
            'Product Code': row.productCode || row.skuCode || '',
            'Product Name': row.productName || '',
            'UOM': getUomLabel(row.measuringUnit),
            'Available Stock': row.availableQuantity !== undefined && row.availableQuantity !== null && row.availableQuantity !== ''
                ? Number(row.availableQuantity).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                : ''
        }));

        if (!content || content.length === 0) return;

        const columns = Object.keys(content[0]).map((key) => ({ label: key, value: key }));

        const settings = {
            sheetName: 'Stock Management',
            fileName: 'Stock Management_' + new Date().toISOString().split('T')[0],
            writeOptions: {}
        };

        const dataA = [
            {
                sheet: 'Stock Management',
                columns,
                content
            }
        ];

        xlsx(dataA, settings);
    }

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            factoryID: formData.factoryID,
            productCategoryID: formData.productCategoryID,
            productID: formData.productID,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });

    const isFutureDateDisabled = (date) => {
        return date > new Date();
    };

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSTOCKMANAGEMENT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
        var isFreezeEnabled = permissions.find(p => p.permissionCode == 'FREEZESTOCK');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            isFreezeEnabled: isFreezeEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategories());
    }

    async function SubmitForm() {
        let model = {
            groupID: formik.values.groupID,
            factoryID: formik.values.factoryID,
            productCategoryID: formik.values.productCategoryID,
            productID: formik.values.productID,
        }
        var response = await services.GetStockBalanceReportData(model);
        setStockBalanceDetails(response);
        getSelectedDropdownValuesForReport(model);
    } 
    
    const { errors, setValues, setFieldValue, touched, handleSubmit, getFieldProps, values } = formik;

    const handleGroupChange = async (event) => {
        const groupID = Number(event.target.value);
        setValues({
            ...formik.values,
            groupID,
            factoryID: 0,
            productCategoryID: 0,
            productID: 0,
        });
        setFactory([]);
        setProduct([]);
        setStockBalanceDetails([]);

        if (groupID !== 0) {
            trackPromise(GetFactoriesByGroupID(groupID));
        }
    };

    const handleFactoryChange = async (event) => {
        const factoryID = Number(event.target.value);

        setValues({
            ...formik.values,
            factoryID,
            productCategoryID: 0,
            productID: 0,
        });
        setProduct([]);
        setStockBalanceDetails([]);
    };

    const handleProductCategoryChange = async (event) => {
        const productCategoryID = Number(event.target.value);

        setValues({
            ...formik.values,
            productCategoryID,
            productID: 0,
        });
        setProduct([]);
        setStockBalanceDetails([]);

        if (productCategoryID !== 0) {
            trackPromise(GetProductDetails(formik.values.factoryID, productCategoryID));
        }
    };

    const handleProductChange = (event) => {
        setFieldValue('productID', Number(event.target.value));
        setStockBalanceDetails([]);
    };

    async function clearAll() {
        setValues({
            ...values,
            productCategoryID: 0,
            productID: 0,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
        });
        setStockBalanceDetails([]);
    }

    useEffect(() => {
        if (formik.values.groupID !== 0) {
            trackPromise(GetFactoriesByGroupID(formik.values.groupID));
        }
    }, [formik.values.groupID]);

    useEffect(() => {
        setFreezeStatus({ isFrozen: false });
        if (formik.values.groupID > 0) {
            trackPromise(GetStockFreezeStatus());
        }
    }, [formik.values.groupID]);

    async function GetStockFreezeStatus() {
        var res = await services.GetStockFreezeStatus(formik.values.groupID);
        if (res != null) {
            setFreezeStatus(res);
        } else {
            setFreezeStatus({ isFrozen: false });
        }
    }

    async function FreezeStock() {
        var res = await services.FreezeStock(formik.values.groupID, parseInt(TokenDecoder.getUserIDFromToken()));
        if (res.statusCode === "Success") {
            toast.success(res.message);
        } else {
            toast.error(res.message);
        }
        trackPromise(GetStockFreezeStatus());
    }

    async function UnfreezeStock() {
        var res = await services.UnfreezeStock(formik.values.groupID, parseInt(TokenDecoder.getUserIDFromToken()));
        if (res.statusCode === "Success") {
            toast.success(res.message);
        } else {
            toast.error(res.message);
        }
        trackPromise(GetStockFreezeStatus());
    }

    function handleFreezeClick() {
        if (!(formik.values.groupID > 0)) {
            formik.setTouched({ ...formik.touched, groupID: true });
            return;
        }
        setEnableFreezeConfirm(true);
    }

    function handleUnfreezeClick() {
        if (!(formik.values.groupID > 0)) {
            formik.setTouched({ ...formik.touched, groupID: true });
            return;
        }
        setEnableUnfreezeConfirm(true);
    }

    function confirmFreeze(y) {
        if (y) {
            trackPromise(FreezeStock());
        }
    }

    function confirmUnfreeze(y) {
        if (y) {
            trackPromise(UnfreezeStock());
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID(groupID = formik.values.groupID) {
        const factoryType = parseInt(TokenDecoder.getFactoryTypeFromToken());
        var res = await services.GetAllFactoriesByFactoryType(groupID, factoryType);
        if (res != null) {
            setFactory(res);
        }
    }

    async function GetProductCategories() {
        var res = await services.GetProductCategories();
        if (res != null) {
            setProductcategory(res);
        }
    }

    async function GetProductDetails(factoryID = formik.values.factoryID, productCategoryID = formik.values.productCategoryID) {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(factoryID, productCategoryID);
        if (res != null) {
            var availableProducts = res.filter((item) => item.isActive === true);
            setProduct(availableProducts);
        } else {
            setProduct([]);
        }
    }

    function getSelectedDropdownValuesForReport(data) {
        let groups = group.find(x => x.groupID == formik.values.groupID)
        let factories = factory.find(x => x.factoryID == formik.values.factoryID);
        let productcategories = productcategory.find(x => x.value == formik.values.productCategoryID);
        let products = product.find(x => x.value == formik.values.productID);

        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups.groupName,
            factory: factories.factoryName,
            productCategory: productcategories.productCategoryName,
            product: products.productName,
        });
    }

    function generateProductCategoryDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(x.isActive == true ? <MenuItem key={x.productCategoryID} value={x.productCategoryID}>{x.productCategoryName}</MenuItem> : null)
            });
        }
        return items
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Stock Management |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/stockManagement"}
                        btname="Add"
                        pageName="Stock Management"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        name="groupID"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={handleGroupChange}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        name="factoryID"
                                        label="Operation Entity *"
                                        value={formik.values.factoryID}
                                        onChange={handleFactoryChange}
                                        error={Boolean(touched.factoryID && errors.factoryID)}
                                        helperText={touched.factoryID && errors.factoryID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Operation Entity</MenuItem>
                                        {factory.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        name="productCategoryID"
                                        label="Product Category"
                                        value={formik.values.productCategoryID}
                                        onChange={handleProductCategoryChange}
                                        error={Boolean(touched.productCategoryID && errors.productCategoryID)}
                                        helperText={touched.productCategoryID && errors.productCategoryID}
                                    >
                                        <MenuItem key={0} value={0}> Select Product Category</MenuItem>
                                        {generateProductCategoryDropDownMenu(productcategory)}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Product"
                                        value={formik.values.productID}
                                        onChange={handleProductChange}
                                        name="productID"
                                        error={Boolean(touched.productID && errors.productID)}
                                        helperText={touched.productID && errors.productID}
                                    >
                                        <MenuItem key={0} value={0}> Select Product</MenuItem>
                                        {product.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.productID} value={option.productID}>
                                                {option.productName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                </Stack>
                                <div>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center" spacing={2}>
                                        <Stack direction="row" alignItems="center" spacing={2}>
                                            {permissionList.isFreezeEnabled ?
                                                (freezeStatus.isFrozen == true ?
                                                    <Button
                                                        type="button"
                                                        variant="contained"
                                                        style={{ backgroundColor: '#FFC107', color: '#fff' }}
                                                        onClick={() => handleUnfreezeClick()}
                                                    >Unfreeze</Button>
                                                    :
                                                    <Button
                                                        type="button"
                                                        variant="contained"
                                                        style={{ backgroundColor: '#FFC107', color: '#fff' }}
                                                        onClick={() => handleFreezeClick()}
                                                    >Freeze Stock</Button>)
                                                : null}
                                            {freezeStatus.isFrozen == true ?
                                                <Chip
                                                    label={"Stock Frozen - " + (freezeStatus.frozenByName || '') + (freezeStatus.frozenDate ? ' - ' + new Date(freezeStatus.frozenDate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) : '')}
                                                    color="error"
                                                    variant="outlined"
                                                />
                                                : null}
                                        </Stack>
                                        <Stack direction="row" spacing={2}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color='error'
                                                onClick={() => clearAll()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                color='secondary'
                                                variant="outlined"
                                            >Search</Button>
                                        </Stack>
                                    </Stack>
                                </div>
                            </Stack>
                            <br />
                            <>
                                {stockBalanceDetails.length > 0 ? (
                                    <Card style={{ justifycontent: 'center', width: '100%' }}>
                                        <Paper className={classes.paper}>
                                            <TableContainer>
                                                <Table className={classes.table} aria-label="collapsible table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Product Category</TableCell>
                                                            <TableCell>Product Code</TableCell>
                                                            <TableCell>Product Name</TableCell>
                                                            <TableCell>UOM</TableCell>
                                                            <TableCell align="right">Available Stock</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {stockBalanceDetails
                                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            .map((row, idx) => (
                                                                <StockRow
                                                                    key={row.productID + '-' + row.productCategoryID + '-' + idx}
                                                                    row={row}
                                                                    theme={theme}
                                                                    pillClassName={classes.stockPill}
                                                                />
                                                            ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                            <TablePagination
                                                rowsPerPageOptions={[5, 10, 25]}
                                                component="div"
                                                count={stockBalanceDetails.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                            />
                                        </Paper>
                                    </Card>
                                ) : <SearchNotFound searchQuery="Stock Balance Report" />}
                            </>
                        </Form>
                    </FormikProvider>
                    {stockBalanceDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnExcel"
                                type="button"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Stock Management"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnPdf"
                                    type="button"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    stockBalanceDetails={stockBalanceDetails}
                                    searchData={selectedSearchValues}
                                />
                            </div>
                        </Box> : null}
                </Container>
                <div hidden={true}>
                    <AlertDialog confirmData={confirmFreeze} headerMessage={"Freeze Confirmation"} viewPopup={EnableFreezeConfirm}
                        discription={"Are you sure you want to freeze the stock for this Group ?"} setViewPopup={setEnableFreezeConfirm} />
                </div>
                <div hidden={true}>
                    <AlertDialog confirmData={confirmUnfreeze} headerMessage={"Unfreeze Confirmation"} viewPopup={EnableUnfreezeConfirm}
                        discription={"Are you sure you want to unfreeze the stock for this Group ?"} setViewPopup={setEnableUnfreezeConfirm} />
                </div>
            </Page>
        </>
    );
}